import { SearchAssetTypeEnum } from "@frameworks/web/components/Search/constant";
class SearchPresenter {
    constructor(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    async getTrending(req) {
        return new Promise((resolve, reject) => {
            this.usecase.trendingSearch.execute({
                onSuccess: (data) => {
                    if (req.trendingAssetType && data) {
                        data.type = req.trendingAssetType;
                    }
                    resolve(data);
                },
                onError: (error) => reject(error),
            }, req);
        });
    }
    async saveTrending(req) {
        return new Promise((resolve, reject) => {
            this.usecase.saveTrendingSearch.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    async allAssetTrending() {
        const trendingData = Object.entries(SearchAssetTypeEnum).map(([keys, values]) => {
            return this.getTrending({ trendingAssetType: values });
        });
        const promiseData = await Promise.all(trendingData);
        let data = {
            [SearchAssetTypeEnum.Equity]: [],
            [SearchAssetTypeEnum.Future]: [],
            [SearchAssetTypeEnum.Option]: [],
            [SearchAssetTypeEnum.OptionChain]: [],
            [SearchAssetTypeEnum.MF]: [],
            [SearchAssetTypeEnum.PrimaryMarket]: [],
            [SearchAssetTypeEnum.Commodity]: [],
            [SearchAssetTypeEnum.Currency]: [],
            [SearchAssetTypeEnum.ETFs]: [],
            [SearchAssetTypeEnum.Indices]: [],
            [SearchAssetTypeEnum.NcdSecondary]: [],
            // [SearchAssetTypeEnum.SGB]: [],
            // [SearchAssetTypeEnum.CORPFD]: [],
            [SearchAssetTypeEnum.ComFut]: [],
            [SearchAssetTypeEnum.ComOpt]: [],
        };
        promiseData
            .filter((x) => x)
            .map((x) => {
            data[x.type] = !!(x === null || x === void 0 ? void 0 : x.trending) ? x.trending : [];
        });
        return data;
    }
    getOptionChainToolData(req) {
        this.actions.optionChainToolActions.hideError();
        this.actions.optionChainToolActions.loader();
        return new Promise((resolve, reject) => {
            this.usecase.optionChainTool.execute({
                onSuccess: (data) => {
                    if (data) {
                        this.actions.optionChainToolActions.getOptionChainToolData(data);
                    }
                    this.actions.optionChainToolActions.stopLoader();
                    resolve(data);
                },
                onError: (error) => {
                    this.actions.optionChainToolActions.setError({
                        isOpen: true,
                        error,
                    });
                    this.actions.optionChainToolActions.stopLoader();
                    reject(error);
                },
            }, req);
        });
    }
    getGeneralSearch(req) {
        return new Promise((resolve, reject) => {
            this.usecase.genSearch.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getAssetTypeSearch(type, req) {
        req.pageSize = 50;
        return new Promise((resolve, reject) => {
            this.usecase.assetSearch[type].execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
}
export default SearchPresenter;
